export const GET_AUTH_DIALOG_VISIBILITY_STATUS =
  "GET_AUTH_DIALOG_VISIBILITY_STATUS";

const getters = {
  [GET_AUTH_DIALOG_VISIBILITY_STATUS]: state => state.showAuthDialog
};

export default getters;
